
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize&sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-9db9202e\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./rename.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./rename.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-9db9202e\"}!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./rename.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/rename/rename.vue
// module id = 275
// module chunks = 1